import { FileText, MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateIntercomCustomFieldsFillUpAr: TemplateAr = {
  name: 'أتمتة تعبئة حقول Intercom المخصصة بالذكاء الاصطناعي',
  description:
    'تعبئة حقول Intercom المخصصة تلقائياً أثناء المحادثات، وإنهاء الإدخال اليدوي للبيانات على فريق الدعم.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'العميل' },
    { icon: Sparkles, label: 'استخراج ذكي' },
    { icon: FileText, label: 'الحقول معبّأة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'خلّ سمات Intercom تتعبّى وأنت في المحادثة، مو بعد ما تخلص. الـ AI يقرأ محادثات عملائك، ويطلع منها النقاط الأساسية، ويحدّث سمات المستخدم والشركة لحظياً.',
    paragraph2:
      'بيانات السمات تتزامن مباشرة مع Intercom، ومعها سجل تدقيق كامل. والنظام يشتغل جنب سير العمل والبوتات اللي عندك في Intercom أصلاً، والـ AI يتأقلم مع نموذج بياناتك وتعريفات السمات المخصصة عندك فيه.',
  },
  benefits: [
    'خلّص موظفيك من الإدخال اليدوي',
    'كل سمة تتعبّى بنفس الطريقة، كل مرة',
    'وقت معالجة المحادثة ينزل وتلاحظ الفرق',
    'بيانات Intercom عندك تطلع أنظف',
    'كل تعبئة لها سجل تدقيق كامل للامتثال',
    'يشتغل مع كل سمات Intercom المخصصة عندك',
  ],
};
